import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

//import Services
import {
  authState,
  authGetters,
  authAcctions,
  authMutations,
} from "./store/services/authService";

import {
  userState,
  userGetters,
  userAcctions,
  userMutations,
} from "./store/services/userService";

import {
  campaignState,
  campaignGetters,
  campaignAcctions,
  campaignMutations,
} from "./store/services/CampaignService";

import {
  setState,
  setGetters,
  setAcctions,
  setMutations,
} from "./store/services/setAdsService";

import {
  generalState,
  generalGetters,
  generalActions,
  generalMutations,
} from "./store/services/generalService";

import {
  partnerState,
  partnerGetters,
  partnerActions,
  partnerMutations,
} from "./store/services/partnerService";

import {
  offertState,
  offertGetters,
  offertActions,
  offertMutations,
} from "./store/services/offertService";

import {
  businessState,
  businessGetters,
  businessActions,
  businessMutations,
} from "./store/services/businessService";

import {
  ruleState,
  ruleGetters,
  ruleActions,
  ruleMutations,
} from "./store/services/ruleService";

import {
  pixelState,
  pixelGetters,
  pixelActions,
  pixelMutations,
} from "./store/services/pixelService";

import {
  pageState,
  pageGetters,
  pageActions,
  pageMutations,
} from "./store/services/pageService";

import {
  lineState,
  lineGetters,
  lineActions,
  lineMutations,
} from "./store/services/lineService";

import {
  strategyActionState,
  strategyActionGetters,
  strategyActionActions,
  strategyActionMutations,
} from "./store/services/strategyActionService";

import {
  stereotypeState,
  stereotypeGetters,
  stereotypeActions,
  stereotypeMutations,
} from "./store/services/stereotypeService";

import {
  adsAccState,
  adsAccGetters,
  adsAccActions,
  adsAccMutations,
} from "./store/services/adsAccountsService";

import {
  promotionState,
  promotionGetters,
  promotionActions,
  promotionMutations,
} from "./store/services/promotionService";

import {
  propuestaState,
  propuestaGetters,
  propuestaActions,
  propuestaMutations,
} from "./store/services/propuestaService";

import {
  codPostalState,
  codPostalGetters,
  codPostalActions,
  codPostalMutations,
} from "./store/services/codPostalService";

import {
  ideologiaState,
  ideologiaGetters,
  ideologiaActions,
  ideologiaMutations,
} from "./store/services/ideologiaService";

import {
  provinciaState,
  provinciaGetters,
  provinciaActions,
  provinciaMutations,
} from "./store/services/provinciaService";

import {
  audienciaState,
  audienciaGetters,
  audienciaActions,
  audienciaMutations,
} from "./store/services/audienciaPersonalizadaService";

import {
  adsetsState,
  adsetsGetters,
  adsetsActions,
  adsetsMutations,
} from "./store/services/AdsetsService";

import {
  adsState,
  adsGetters,
  adsMutations,
  adsActions,
} from "./store/services/AdsService";

import {
  webSiteState,
  webSiteGetters,
  webSiteMutations,
  webSiteActions,
} from "./store/services/webSitesService";

import {
  quizState,
  quizGetters,
  quizMutations,
  quizActions,
} from "./store/services/QuizService";

import {
  ModerateState,
  ModerateGetter,
  ModerateActions,
  ModerateMutations,
} from "./store/services/ActionsServices";

import {
  insightState,
  insightGetters,
  insightActions,
  insightMutations,
} from "./store/services/InsightService";

import {
  trustpilotState,
  trustpilotGetters,
  trustpilotActions,
  trustpilotMutations,
} from "./store/services/TrustPilotService";

import {
  GMBState,
  GMBGetter,
  GMBActions,
  GMBMutations,
} from "./store/services/gmbService";

import {
  notifyState,
  notifyGetters,
  notifyActions,
  notifyMutations,
} from "./store/services/NotifyService";

Vue.use(Vuex);

const state = {
  sidebarShow: "responsive",
  sidebarMinimize: false,
  ...authState,
  ...userState,
  ...campaignState,
  ...setState,
  ...generalState,
  ...partnerState,
  ...offertState,
  ...businessState,
  ...ruleState,
  ...pixelState,
  ...pageState,
  ...lineState,
  ...strategyActionState,
  ...stereotypeState,
  ...adsAccState,
  ...promotionState,
  ...propuestaState,
  ...codPostalState,
  ...ideologiaState,
  ...provinciaState,
  ...audienciaState,
  ...adsetsState,
  ...adsState,
  ...webSiteState,
  ...quizState,
  ...ModerateState,
  ...insightState,
  ...trustpilotState,
  ...GMBState,
  ...notifyState,
};
const getters = {
  //funciones para optener informacion del state
  ...authGetters,
  ...userGetters,
  ...campaignGetters,
  ...setGetters,
  ...generalGetters,
  ...partnerGetters,
  ...offertGetters,
  ...businessGetters,
  ...ruleGetters,
  ...pixelGetters,
  ...pageGetters,
  ...lineGetters,
  ...strategyActionGetters,
  ...stereotypeGetters,
  ...adsAccGetters,
  ...promotionGetters,
  ...propuestaGetters,
  ...codPostalGetters,
  ...ideologiaGetters,
  ...provinciaGetters,
  ...audienciaGetters,
  ...adsetsGetters,
  ...adsGetters,
  ...webSiteGetters,
  ...quizGetters,
  ...ModerateGetter,
  ...insightGetters,
  ...trustpilotGetters,
  ...GMBGetter,
  ...notifyGetters,
};
const actions = {
  ...authAcctions,
  ...userAcctions,
  ...campaignAcctions,
  ...setAcctions,
  ...generalActions,
  ...partnerActions,
  ...offertActions,
  ...businessActions,
  ...ruleActions,
  ...pixelActions,
  ...pageActions,
  ...lineActions,
  ...strategyActionActions,
  ...stereotypeActions,
  ...adsAccActions,
  ...promotionActions,
  ...propuestaActions,
  ...codPostalActions,
  ...ideologiaActions,
  ...provinciaActions,
  ...audienciaActions,
  ...adsetsActions,
  ...adsActions,
  ...webSiteActions,
  ...quizActions,
  ...ModerateActions,
  ...insightActions,
  ...trustpilotActions,
  ...GMBActions,
  ...notifyActions,
};
const mutations = {
  ...authMutations,
  ...userMutations,
  ...campaignMutations,
  ...setMutations,
  ...generalMutations,
  ...partnerMutations,
  ...offertMutations,
  ...businessMutations,
  ...ruleMutations,
  ...pixelMutations,
  ...pageMutations,
  ...lineMutations,
  ...strategyActionMutations,
  ...stereotypeMutations,
  ...adsAccMutations,
  ...promotionMutations,
  ...propuestaMutations,
  ...codPostalMutations,
  ...ideologiaMutations,
  ...provinciaMutations,
  ...audienciaMutations,
  ...adsetsMutations,
  ...adsMutations,
  ...webSiteMutations,
  ...quizMutations,
  ...ModerateMutations,
  ...insightMutations,
  ...trustpilotMutations,
  ...GMBMutations,
  ...notifyMutations,

  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarOpened ? false : "responsive";
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarClosed ? true : "responsive";
  },
  set(state, [variable, value]) {
    console.log("state[variable], value :::: ", state[variable], value);
    state[variable] = value;
  },
};

export default new Vuex.Store({
  actions,
  getters,
  state,
  mutations,
});
